import React, { useEffect } from "react";
import RestaurantsComp from "../Components/Restaurants/Restaurants";
const Restaurants = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <RestaurantsComp />;
};

export default Restaurants;
